export type { IExchangeRate } from "./interfaces";
export { useGetExchangeRates } from "./useGetExchangeRates";
